module.exports = {
  ASC: "A",
  DESC: "D",
};
